<template>
    <div class="login-container" @keydown.enter="handleLogin">
        <div class="content-box">
            <div class="login-win box-item">
                <div class="logo-box">
                    <div class="logo-main">
                        <div class="box-item">
                            <!-- <img class="logo-img" src="../../assets/images/login/web-c30logo.png"> -->
                            <img class="logo-img" :src="`${logoPath}?${timestamp}`">
                        </div>
                        <div class="box-item">
                            <span class="logo-txt">{{logoTitle}}数据看板</span>
                        </div>
                    </div>
                </div>
                <div class="form-box">
                    <Form ref="loginForm" :model="account" :rules="rules">
                        <FormItem prop="username" style="margin-bottom:0;">
                            <div class="form-item">
                                <div class="box-item">
                                    <img class="name-img" src="../../assets/images/login/login-username-icon.png">
                                </div>
                                <div class="box-item">
                                    <input type="text" placeholder="请输入用户名" @on-focus="focusInput='name'"
                                           @on-blur="focusInput=''" v-model="account.username"
                                           :autofocus="userNameFocus">
                                </div>
                            </div>
                        </FormItem>
                        <FormItem prop="pwd" style="margin-bottom:0;">
                            <div class="form-item">
                                <div class="box-item">
                                    <img class="pass-img" src="../../assets/images/login/password-icon.png">
                                </div>
                                <div class="box-item">
                                    <input @on-focus="focusInput='pwd'" @on-blur="focusInput=''" type="password"
                                           v-model="account.pwd" placeholder="请输入密码" :autofocus="pwdFocus">
                                </div>
                            </div>
                        </FormItem>
                    </Form>
                    <div class="pwd-item">
                        <div class="save-pwd">
                            <Checkbox v-model="checkedPwd">记住密码</Checkbox>
                        </div>
                    </div>
                    <div class>
                        <button v-on:click="handleLogin" class="logo-btn">登录</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="login-footer">©Copyright {{copyrightTitle}} 版权所有</div>
        <!-- 选择用户角色 -->
        <select-user-type ref="selectUserType" :isShow="isShow" :userRoleList="userRoleList"
                          @updateUserType="updateUserType"></select-user-type>
    </div>
</template>

<script>
    let Base64 = require("js-base64").Base64;
    const selectUserType = () => import("../../components/selectUserType");
    export default {
        data() {
            return {
                focusInput: "",
                userNameFocus: true,
                pwdFocus: false,
                account: {
                    username: "",
                    pwd: "",
                    userType: "",
                    loading: false
                },
                rules: {
                    username: [{
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }],
                    pwd: [{
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    }]
                },
                checkedPwd: false,
                isShow: false, //是否显示选择角色弹框
                userRoleList: [], //用户角色
                logoPath: process.env.VUE_APP_LOGIN_LOGO_PATH,
                logoTitle: process.env.VUE_APP_LOGO_TITLE,
                timestamp: (new Date()).getTime(),
                copyrightTitle: process.env.VUE_APP_COPYRIGHT_TITLE
            };
        },
        created(){
            this.clearCookie();
        },
        components: {
            selectUserType
        },
        methods: {
        /**
         * 清除cookie
         */
        clearCookie() {
            this.$utils.clearCookieByPaths([
                "mk-sso-ticket",
                "token",
                "userid",
                "realname",
                "schoolid",
                "schoolName",
                "admin_type",
                "userType",
                "userLoginType",
                "agentId",
                "agentName"
            ]);
        },
            handleLogin() {
                let _this = this;
                if (_this.account.username != "") {
                    _this.account.loading = true;
                    _this.$refs["loginForm"].validate(callback => {
                        if (callback) {
                            let loginParams = {
                                account: _this.account.username.trim(),
                                passWord: _this.account.pwd.trim(),
                                userType: _this.account.userType
                            };
                            _this.$store
                                .dispatch("userLogin", loginParams)
                                .then(res => {
                                    //重置多角色集合和显示弹框，userType
                                    _this.resetParamData();
                                    document.cookie = "savePwd=" + _this.checkedPwd + ";path=/";
                                    //如果用户为代理商则获取代理商id
                                    if (res.user_type == 4) {
                                        _this.$store.dispatch('findAgentInfoByUserId', {
                                            userId: res.id
                                        }).then(() => {
                                            _this.judgeRouteByType(res);
                                        }).catch(res => {
                                        });
                                    }else{
                                        _this.judgeRouteByType(res);
                                    }

                                })
                                .catch(res => {
                                    if (res.code == 2) {
                                        //当用户是多重角色时，从用户选择的角色里的用户角色权限
                                        _this.isShow = true;
                                        _this.userRoleList = res.data;
                                    } else {
                                        _this.$Message.error(res.msg);
                                        //重置多角色集合和显示弹框，userType
                                        _this.resetParamData();
                                    }
                                });
                        }
                    });
                }
            },
            /**
             * 通过用户类型判断路由
             */
            judgeRouteByType(res) {
                //判断admin_type是否为系统管理员或校管理员或代理商或运营
                // admin_type==1:总管理 admin_type == 2:校管  user_type:4:代理商  user_type：5：运营
                if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5) {
                    if (res.user_type == 4) {
                        // 代理商跳转至区域数据展板页面
                        this.$router.push({
                            name: "regiondataboard",
                            query: {
                                agentId: this.$store.getters.agentId,
                                agentName: this.$store.getters.agentName
                            }
                        });
                    } else if (res.admin_type == 2) {
                        // 跳转至学校页面
                        this.$router.push({
                            name: this.$store.getters.schoolId=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                            params: {
                                schoolId: this.$store.getters.schoolId
                            }
                        });
                    } else {
                        //其他
                        this.$router.push({
                            name: 'schooldataboard',
                            params: {
                                schoolId: "0"
                            }
                        });
                    }
                } else {
                    this.$Message.error('抱歉，您暂无权限登录该系统！');
                }
            },
            /**
             * 选择当前角色作为本次登录的角色
             */
            updateUserType(userType) {
                this.account.userType = userType;
                this.handleLogin();
            },
            /**
             * 重置多角色集合和显示弹框，userType
             */
            resetParamData() {
                this.isShow = false;
                this.userRoleList = [];
                this.account.userType = "";
            },
            //表单提交时报错后不显示提交按钮load
            showLoad() {
                let _this = this;
                setTimeout(function () {
                    _this.account.loading = true;
                    _this.$nextTick(() => {
                        _this.account.loading = false;
                    });
                }, 100);
            }
        },
        mounted() {
            if (this.$utils.getCookie("savePwd") === "true") {
                this.checkedPwd = true;
                this.account.username = this.$utils.getCookie("account");
                this.account.pwd = Base64.decode(this.$utils.getCookie("passWord"));
                if (this.account.username != "") {
                    this.userNameFocus = false;
                    this.pwdFocus = true;
                }
            } else {
                this.checkedPwd = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../style/login.scss";

    .login-container {
        width: 100%;
        height: 100%;

        background: {
            image: url("../../assets/images/login/login-bg.png");
            repeat: no-repeat;
            size: cover;
            position: top;
        }
    }
</style>
<style lang="scss">
    .ivu-checkbox {
        margin-right: 8px;
    }
</style>
